export default __webpack_public_path__ + "static/media/sub_page_info_en.632ae45c.svg";